import { DrawerState } from './types'

const initialState: DrawerState = {
  actives: [],
  data: {}
}

export default initialState
